module.exports = __webpack_public_path__ + "img/icon_chat.e27baceb.png";